import screens from '../..';
import { checkDynamicGameRooms } from '../../../state/query/games/utils';
import { setActiveGameRoom } from '../../../state/slices/gameRooms/gameRooms';
import store from '../../../state/store';
import QueryParamProxy from '../../../utils/queryParamProxy';
import { GAME_ROOMS_SCREEN } from '../constants';
export var handleNewActiveGameRoom = function handleNewActiveGameRoom(navigation, room) {
  var isDynamicRoom = checkDynamicGameRooms();
  if (isDynamicRoom) {
    var getState = store.getState,
      dispatch = store.dispatch;
    var gameRooms = getState().gameRooms.data;
    var activeGameRoom = gameRooms.find(function (_ref) {
      var urlPath = _ref.urlPath;
      return urlPath === GAME_ROOMS_SCREEN[room];
    });
    dispatch(setActiveGameRoom(activeGameRoom));
    QueryParamProxy.navigate(navigation, screens.Home);
  } else {
    QueryParamProxy.navigate(navigation, room);
  }
};